import axiosInstance from "@/api/axios-instance";

export async function updateBehaviorTags({
  userId,
  tags,
}: {
  userId: string;
  tags: string[];
}) {
  const response = await axiosInstance.patch(`/users/${userId}/behavior-tags`, {
    tags,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to update behavior tags");
  }

  return response.data;
}

